import angular from 'angular';
import utils from 'utils/lsp-utils-service';
/* validators */
import lspEmail from './lsp-email-validator/lsp-email-directive';
import lspEmails from './lsp-emails-validator/lsp-emails-directive';
import lspMatch from './lsp-field-matching-validator/lsp-field-matching-directive';
import lspPhoneLength from './lsp-phone-length-validator/lsp-phone-length-directive';
import lspName from './lsp-name-validator/lsp-name-directive';
import lspPassword from './lsp-password-validator/lsp-password-directive';
import LspFormFieldService from './lsp-form-field-validator/lsp-form-field-service';
import lspFormField from './lsp-form-field-validator/lsp-form-field-directive';
import retailerNumberPattern from './retailer-number-pattern/retailer-number-pattern-directive';
import spaceLeadingPattern from './space-leading-pattern/space-leading-pattern-directive';
import googleMapsCoords from './google-maps-coords-validator/google-maps-coords-directive';
import strippedMaxLength from './stripped-max-length';

export default angular
  .module('lsp-validators', [])
  .directive('lspEmail', utils.createNgFactory(lspEmail))
  .directive('lspEmails', utils.createNgFactory(lspEmails))
  .directive('lspMatch', utils.createNgFactory(lspMatch))
  .directive('lspPhoneLength', utils.createNgFactory(lspPhoneLength))
  .directive('lspName', utils.createNgFactory(lspName))
  .directive('lspPassword', utils.createNgFactory(lspPassword))
  .directive('lspFormField', utils.createNgFactory(lspFormField))
  .directive('googleMapsCoords', utils.createNgFactory(googleMapsCoords))
  .directive('retailerNumberPattern', utils.createNgFactory(retailerNumberPattern))
  .directive('spaceLeadingPattern', utils.createNgFactory(spaceLeadingPattern))
  .directive('strippedMaxLength', utils.createNgFactory(strippedMaxLength))
  .service('LspFormFieldService', LspFormFieldService);



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-validators-module.js